// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"purify_Layout__wrapper___b3P_6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Layout/Layout.scss
// module id = 172
// module chunks = 0